// Forbidden Romance Book Club — Global JS

document.addEventListener('DOMContentLoaded', function() {

  // Variant selection
  document.querySelectorAll('.product__option-values').forEach(group => {
    group.addEventListener('click', e => {
      if (e.target.classList.contains('product__option-value')) {
        group.querySelectorAll('.product__option-value').forEach(btn => {
          btn.classList.remove('is-selected');
        });
        e.target.classList.add('is-selected');
      }
    });
  });

  // Newsletter pseudo-submit (Shopify form will handle on real install)
  document.querySelectorAll('.newsletter__form').forEach(form => {
    form.addEventListener('submit', e => {
      const input = form.querySelector('.newsletter__input');
      if (!input.value) {
        e.preventDefault();
      }
    });
  });

  // Quick-add buttons
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      btn.textContent = 'Added ♥';
      setTimeout(() => {
        btn.textContent = btn.dataset.originalText || 'Quick Add';
      }, 1500);
    });
  });

  // Fade in on scroll
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-up');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('[data-animate]').forEach(el => {
    observer.observe(el);
  });

});
